<div class="flex flex-col w-full h-full gap-4 min-w-[20rem]">
  @if (centers() && centers()!.length > 0) {
    <div class="md:p-2 p-4 flex flex-col gap-4">
      <div class="flex flex-col gap-2 max-h-[30rem] overflow-y-auto">
        @for (center of centers(); track $index) {
          <app-center-profile
            [active]="currentCenter()?.id === center.id"
            (click)="select.emit(center)"
            [center]="center"
            class="cursor-pointer"
          />
        }
      </div>
      <div class="flex items-center">
        <button (click)="handleNavigate('/center/form')">
          <app-icon name="mdi:plus" class="text-gray-400 !size-5" />
          <p class="text-sm text-gray-400">센터 생성</p>
        </button>
        <div class="h-3 w-px bg-gray-200"></div>
        <button (click)="handleNavigate('/center/find')">
          <app-icon name="mdi:search" class="text-gray-400 !size-5" />
          <p class="text-sm text-gray-400">센터 찾기</p>
        </button>
      </div>
    </div>
  } @else {
    <div
      class="flex flex-col w-full min-h-[10rem] items-center justify-center h-full"
    >
      <div class="flex flex-col gap-3 items-center">
        <p class="text-gray-800 font-semibold">소속된 센터가 없어요.</p>
        <p class="text-gray-500 text-sm">
          센터를 찾거나 직접 센터를 등록해주세요.
        </p>
      </div>
    </div>
    <div class="border-t">
      <div class="flex items-center divide-x">
        <button
          class="hover:bg-gray-50"
          (click)="handleNavigate('/center/form')"
        >
          <app-icon
            name="material-symbols:add-home-work"
            class="!size-5 text-gray-400"
          />
          <p class="text-gray-800 font-semibold text-sm">센터 생성</p>
        </button>
        <button (click)="createPrivateCenter()" class="hover:bg-gray-50">
          <app-icon name="mdi:person" class="!size-5 text-gray-400" />
          <p class="text-gray-800 font-semibold text-sm min-w-max">
            개인으로 활동
          </p>
        </button>
      </div>
      <button
        (click)="handleNavigate('/center/find')"
        class="bg-primary hover:bg-primary-450 px-3 py-2 w-full flex gap-1 items-center justify-center"
      >
        <app-icon name="ic:round-search" class="!size-5 text-white" />
        <p class="text-white text-sm font-semibold">센터 찾기</p>
      </button>
    </div>
  }
</div>
